/* eslint-disable import/prefer-default-export */
const defaultObj = {};

export const getEmployeeDetails = (state) => state.GetEmployeeDetials.employeeDetails || defaultObj;
export const getIsLoadingEmployeeDetails = (state) => state.GetEmployeeDetials.isLoadingEmployeeDetails || false;
